<template>
    <div v-if="isLinkedToArticle" :class="{ 'merlin-asset-border': isMerlinMedia }">

        <b-card :id="'related-media-item' + item.id" header-bg-variant="white" no-body>
            <template #header>
                <CardID :id="item.id" :type="'Media'"/>
                <span
                    v-if="isMerlinMedia"
                    class="merlin-asset-warning"
                >
                    <font-awesome-icon :icon="['fas', 'exclamation-triangle']" fixed-width />
                    Merlin Asset
                </span>
                <div class="d-flex align-items-center">
                    <div class="flex-grow-1 mr-3">
                        <div class="d-flex align-items-center">
                            <div>
                                <span

                                    class="collapse-icon mr-2"
                                    :class="item.visible ? null : 'collapsed'"
                                    :aria-expanded="item.visible ? 'true' : 'false'"
                                    @click="toggleVisibility('visible')"
                                >
                                    <span class="open">
                                        <font-awesome-icon :icon="['fas', 'caret-down']" fixed-width/>
                                    </span>
                                    <span class="closed">
                                        <font-awesome-icon :icon="['fas', 'caret-right']" fixed-width/>
                                    </span>
                                </span>
                            </div>

                            <div class="mr-2">
                                <div v-if="thumbnail">
                                    <b-link :href="thumbnail" target="_blank" class="pl-2">
                                        <b-img
                                            :src="thumbnail"
                                            width="75"
                                            height="auto"
                                            class="p-0"
                                            thumbnail
                                        />
                                    </b-link>
                                </div>
                            </div>

                            <div class="flex-grow-1 mr-3">
                                <Title
                                    v-model="mappedItem.name"
                                    :article="article"
                                    :item="mappedItem"
                                    :variant="'light'"
                                    @update="updateTitle"
                                    :disabled="disabled"
                                />
                            </div>
                            <div>
                                <b-badge variant="secondary">
                                    <span v-if="item.type === 'video'">
                                        <font-awesome-icon :icon="['fad', 'video']" fixed-width/> Video
                                    </span>
                                    <span v-if="item.type === 'audio'">
                                        <font-awesome-icon :icon="['fad', 'volume']" fixed-width/> Audio
                                    </span>
                                    <span v-if="item.type === 'image'">
                                        <font-awesome-icon :icon="['fad', 'image']" fixed-width/> Image
                                    </span>
                                    <span v-if="item.type === 'sims'">
                                        <font-awesome-icon :icon="['fad', 'code']" fixed-width /> Sims
                                    </span>
                                </b-badge>
                            </div>

                        </div>
                    </div>
                    <div v-if="item.type == 'video'" class="mr-3 d-flex align-items-center">
                        <b-form-checkbox
                            v-model="is_intro_video"
                            :checked="is_intro_video"
                            :disabled="(has_video && has_intro_video && !is_intro_video && article.related_media_intro_video_id) || disabled"
                            switch
                            @change="toggleIntroVideo"
                        >
                            Intro Video
                        </b-form-checkbox>
                    </div>

                    <div class="mr-3 d-flex align-items-center">
                        <b-form-checkbox
                            v-model="item.is_explore_more"
                            :checked="item.is_explore_more"
                            switch
                            @change="toggleExploreMore"
                            :disabled="disabled"
                        >
                            Explore More
                        </b-form-checkbox>
                    </div>

                    <div class="mr-3 d-flex text-left flex-column">
                        <div>
                            <div class="d-flex align-items-center">
                                <div class="mr-1">
                                    <b-dropdown
                                        size="sm"
                                        variant="link"
                                        no-caret
                                        right
                                        class="d-inline-flex"
                                        :disabled="disabled || swapping_related_media_language || relatedMediaLanguageFlags.length < 2"
                                    >
                                        <template #button-content>
                                            <flag
                                                v-if="selectedRelatedMediaLanguageFlag || relatedMediaLanguageFlags.length"
                                                :iso="selectedRelatedMediaLanguageFlag || relatedMediaLanguageFlags[0]"
                                            />
                                            <font-awesome-icon
                                                v-if="showRelatedMediaLanguageDropdownIndicator"
                                                :icon="['fas', 'caret-down']"
                                                class="ml-1"
                                            />
                                        </template>
                                        <b-dropdown-item
                                            v-for="languageFlag in relatedMediaLanguageFlags"
                                            :key="languageFlag"
                                            :active="languageFlag == selectedRelatedMediaLanguageFlag"
                                            :disabled="languageFlag == selectedRelatedMediaLanguageFlag"
                                            @click="swapRelatedMediaLanguage(languageFlag)"
                                        >
                                            <flag :iso="languageFlag"/>
                                            <span class="ml-2">{{ languageFlagLabel(languageFlag) }}</span>
                                        </b-dropdown-item>
                                    </b-dropdown>
                                </div>
                                <div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="ml-auto">
                        <b-dropdown
                            size="sm"
                            variant="secondary"
                            dropleft
                        >
                            <template #button-content>
                                <font-awesome-icon :icon="['fad', 'cog']"/>
                            </template>
                            <b-dropdown-item
                                @click="editItem(item)"
                                :disabled="disabled"
                            >
                                <font-awesome-icon :icon="['fad', 'edit']" class="text-primary" fixed-width/>
                                Edit
                            </b-dropdown-item>
                            <b-dropdown-item
                                v-if="publication && publication.id"
                                @click="unlinkItem(item)"
                                :disabled="disabled"
                            >
                                <font-awesome-icon :icon="['fad', 'unlink']" class="text-warning" fixed-width/>
                                Unlink
                            </b-dropdown-item>
                        </b-dropdown>
                    </div>
                </div>
            </template>
            <b-collapse
                v-model="item.visible"
                :class="item.visible ? null : 'collapsed'"
            >
                <b-card-footer class="border-top-0">
                    <h6>Questions</h6>

                    <div v-for="(question, index) in questions" :key="index" class="question"
                         :class="{'mt-1': index > 0}">
                        <div class="d-flex align-items-center">
                            <div class="mr-2">
                                {{ index + 1 }}.
                            </div>
                            <div class="flex-grow-1">
                                <div v-if="question.id">
                                    <Question
                                        :article="article"
                                        :question="question"
                                        :item="item"
                                        @update="updateQuestion"
                                        @delete="deleteQuestion"
                                        :disabled="disabled"
                                    />
                                </div>
                                <div v-else>
                                    <b-btn
                                        size="sm"
                                        variant="outline-success"
                                        @click.prevent="newQuestion(question.difficulty)"
                                        block
                                        :disabled="disabled"
                                    >
                                        <font-awesome-icon :icon="['fad', 'plus-square']"/>
                                    </b-btn>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class='question mt-1'>
                        <div class="d-flex align-items-center">
                            <div class="mr-2">
                                {{ questions.length + 1 }}.
                            </div>
                            <div class="flex-grow-1">
                                <b-btn
                                    size="sm"
                                    variant="outline-success"
                                    @click.prevent="newQuestion(-1)"
                                    block
                                    :disabled="disabled"
                                >
                                    <font-awesome-icon :icon="['fad', 'plus-square']"/>
                                </b-btn>
                            </div>
                        </div>
                    </div>
                </b-card-footer>
            </b-collapse>
        </b-card>

        <related-media-item-modal
            v-model="show_related_media_item_modal"
            :item="mappedItem"
            @update="saveItem"
            @hide="show_related_media_item_modal = false"
        />

        <question-modal
            v-model="show_question_modal"
            :item="item"
            :question="question"
            @create="createQuestion"
            @update="updateQuestion"
            @hide="show_question_modal = false"
        />
    </div>
</template>

<script>
import moment from 'moment'
import {mapState} from 'vuex'

import CardID from '@/components/CardID'
import Title from '@/components/Title'

import Question from '@/components/article/related_media/Question'

import RelatedMediaItemModal from '@/components/modals/article/related_media/RelatedMediaItemModal'
import QuestionModal from '@/components/modals/questions/QuestionModal'

export default {
    data: () => ({
        question: {},

        show_related_media_item_modal: false,
        show_question_modal: false,
        swapping_related_media_language: false
    }),
    props: {
        'publication': Object,
        'article': Object,
        'related_media_items': Array,
        'item': Object,
        'type': String,
        'disabled': {
            type: Boolean,
            default: false,
        }
    },
    components: {
        CardID,
        Title,
        Question,
        RelatedMediaItemModal,
        QuestionModal
    },
    computed: {
        ...mapState({}),
        isMerlinMedia() {
            return !!(this.item && this.item.url && this.item.url.toLowerCase().includes('merlinone'))
        },
        isLinkedToArticle() {
            return !!this.item.pivot
        },
        questions() {
            return this.item.questions
            let questions = [
                {difficulty: 'easy'},
                {difficulty: 'medium'},
                {difficulty: 'hard'}
            ]
            _.forEach(questions, question => {
                if (this.item.questions) {
                    _.forEach(this.item.questions, q => {
                        if (
                            q.content &&
                            q.content.difficulty == question.difficulty
                        ) {
                            _.assign(question, q)
                        }
                    })
                }
            })

            return questions
        },
        thumbnail() {
            let thumbnail = null

            if (
                this.item &&
                this.item.dam_id
            ) {
                thumbnail = this.item.url
            } else if (!this.item.splash_url) {
                thumbnail = this.item.url;
            } else {
                thumbnail = this.item.splash_url
            }

            return thumbnail
        },
        is_intro_video: {
            get() {
                let is_intro_video = null

                if (
                    (this.item.pivot && this.item.pivot.publication_id == this.publication.id) &&
                    (this.article.related_media_intro_video_id && this.article.related_media_intro_video_id == this.item.id)
                ) {
                    is_intro_video = true
                }

                return is_intro_video
            },
            set() {
            }
        },
        has_video() {
            let has_video = false

            _.forEach(this.related_media_items, item => {
                if (item.type == 'video') {
                    has_video = true
                }
            })

            return has_video
        },
        has_intro_video() {
            let has_intro_video = false

            _.forEach(this.related_media_items, item => {
                if (
                    this.article.related_media_intro_video_id &&
                    item.id == this.article.related_media_intro_video_id
                ) {
                    has_intro_video = true
                }
            })

            return has_intro_video
        },
        relatedMediaLanguageFlags() {
            let related_media_items = [this.item]

            if (this.item.group_id) {
                related_media_items = _.filter(this.related_media_items, item => {
                    return item.group_id == this.item.group_id
                })

                if (!related_media_items.length) {
                    related_media_items = [this.item]
                }
            }

            return _.chain(related_media_items)
                .map(item => item.language)
                .map(language => this.languageToFlag(language))
                .compact()
                .uniq()
                .value()
        },
        selectedRelatedMediaLanguageFlag() {
            return this.languageToFlag(this.item.language)
        },
        showRelatedMediaLanguageDropdownIndicator() {
            return !this.disabled &&
                !this.swapping_related_media_language &&
                this.relatedMediaLanguageFlags.length > 1
        },
        mappedItem() {
            // Ensures name is set, falling back to title.
            let item = this.item
            item.name = item.name ? item.name : (item.title ? item.title : '')

            return item
        },
    },
    methods: {
        getRelatedMedia() {
            this.related_media_loading = true

            this.axios.get('/api/articles/related_media/' + this.article.id)
                .then(response => {
                    let related_media = []

                    if (response.data) {
                        related_media = _.uniqBy(response.data, 'id')
                        related_media = _.orderBy(response.data, 'created')

                        this.$set(this.article, 'related_media', related_media)
                    }
                })
                .catch(error => {
                    if (error) {
                        console.log(error)
                    }
                })
        },
        getExploreMore() {
            this.axios.get('/api/articles/explore_more/' + this.article.id)
                .then(response => {
                    let explore_more = []

                    if (response.data) {
                        explore_more = _.uniqBy(response.data, 'id')
                        explore_more = _.orderBy(response.data, 'created')

                        this.$set(this.article, 'explore_more', explore_more)
                    }
                })
                .catch(error => {
                    if (error) {
                        console.log(error)
                    }
                })
        },
        refresh() {
            this.getRelatedMedia()
            this.getExploreMore()
        },
        editItem() {
            this.show_related_media_item_modal = true
        },
        saveItem(item) {
            // We use `name` in the RelatedMediaItemModal, but store this on the backend with `title`.
            // For this reason, we need to synchronize the two before saving.
            if (item.title !== item.name) {
                item.title = item.name
            }

            this.axios.post('/api/articles/update_explore_more/' + item.id, item)
                .then(() => {
                    this.refresh()

                    this.show_related_media_item_modal = false
                })
        },
        saveItemByProperty(key, value) {
            return new Promise((resolve, reject) => {
                this.axios.post('/api/articles/update_explore_more/' + this.item.id, {
                    [key]: value
                })
                    .then(response => {
                        this.refresh()

                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        updateTitle(title) {
            this.saveItemByProperty('title', title)
                .then(() => {
                    this.$set(this.item, 'title', title)
                })
        },
        async swapRelatedMediaLanguage(languageFlag) {
            if (languageFlag == this.selectedRelatedMediaLanguageFlag) {
                return
            }

            if (!this.item.group_id) {
                return
            }

            let related_media = _.find(this.related_media_items, item => {
                return item.group_id == this.item.group_id && this.languageToFlag(item.language) == languageFlag
            })

            if (!related_media) {
                return
            }

            this.swapping_related_media_language = true

            try {
                if (!this.isRelatedMediaLinkedToCurrentPublication(related_media)) {
                    await this.axios.post('/api/articles/add_related_media/' + this.article.id, {
                        publication_id: this.publication.id,
                        related_media_id: related_media.id
                    })
                }

                await this.axios.post('/api/articles/remove_related_media/' + this.article.article_id, {
                    publication_id: this.publication.id,
                    related_media_id: this.item.id
                })

                if (this.article.related_media_intro_video_id == this.item.id) {
                    let related_media_intro_video_id = related_media.type == 'video' ? related_media.id : null

                    await this.updateArticleByProperty('related_media_intro_video_id', related_media_intro_video_id)
                    this.$set(this.article, 'related_media_intro_video_id', related_media_intro_video_id)
                }

                this.refresh()
            } catch (e) {
                await this.$store.dispatch('pushError', {
                    data: {
                        message: `Failed to swap media to alternate: ${e.message}`,
                    },
                    time: moment().toISOString(),
                })
            } finally {
                this.swapping_related_media_language = false
            }
        },
        languageToFlag(language) {
            if (language == 'en' || language == 'us') {
                return 'us'
            }

            if (language == 'es' || language == 'sp') {
                return 'es'
            }

            return null
        },
        languageFlagLabel(languageFlag) {
            if (languageFlag == 'us') {
                return 'English'
            }

            if (languageFlag == 'es') {
                return 'Spanish'
            }

            return languageFlag
        },
        isRelatedMediaLinkedToCurrentPublication(related_media) {
            return related_media.pivot && related_media.pivot.publication_id == this.publication.id
        },
        unlinkItem(item) {
            let url = null
            let message = null

            if (this.type == 'related_media') {
                url = '/api/articles/remove_related_media/' + this.article.article_id
                message = 'Are you sure you want to unlink this item?'
            }

            this.$swal({
                html: message,
                showCancelButton: true,
                confirmButtonText: 'Unlink Item',
                confirmButtonColor: '#E67E22',
                cancelButtonText: 'Cancel',
                reverseButtons: true
            }).then((result) => {
                if (result.value) {
                    this.axios.post(url, {
                        publication_id: this.publication.id,
                        related_media_id: item.id
                    })
                        .then(() => {
                            if (
                                this.article.related_media_intro_video_id &&
                                this.article.related_media_intro_video_id == item.id
                            ) {
                                this.updateArticleByProperty('related_media_intro_video_id', null)
                                this.$set(this.article, 'related_media_intro_video_id', null)
                            }
                            this.refresh()
                        })
                }
            })
        },
        updateArticleByProperty(key, value) {
            return new Promise((resolve, reject) => {
                this.axios.post('/api/articles/update/' + this.article.article_id, {
                    publication_id: this.publication.id,
                    [key]: value
                })
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        newQuestion(difficulty) {
            if (difficulty == -1) {
                if ((this.questions.length + 1) % 3 == 1) {
                    difficulty = 'easy';
                } else if ((this.questions.length + 1) % 3 == 2) {
                    difficulty = 'medium';
                } else {
                    difficulty = 'hard';
                }
            }

            this.question = {
                type: 'multiple_choice',
                difficulty: difficulty
            }

            this.show_question_modal = true
        },
        createQuestion(question) {

            let obj1 = question.content
            let obj2 = {
                difficulty: question.difficulty,
                grade_level: this.publication.format
            }

            let merged = Object.assign(obj1, obj2)

            this.axios.post('/api/articles/create_explore_more_question/' + this.item.id, {
                type: question.type,
                content: merged,
                print_view: question.print_view,
            })
                .then(() => {
                    this.refresh()

                    this.show_question_modal = false
                })
        },
        updateQuestion() {
            this.refresh()
        },
        deleteQuestion() {
            this.refresh()
        },
        toggleVisibility(value) {
            if (this.item[value]) {
                this.$set(this.item, value, false)
            } else {
                this.$set(this.item, value, true)
            }
        },
        toggleIntroVideo() {
            if (this.article.related_media_intro_video_id) {
                this.axios.post('/api/articles/update/' + this.article.article_id, {
                    publication_id: this.publication.id,
                    related_media_intro_video_id: null
                })
                    .then(() => {
                        this.$set(this.article, 'related_media_intro_video_id', null)
                    })
            } else {
                this.axios.post('/api/articles/update/' + this.article.article_id, {
                    publication_id: this.publication.id,
                    related_media_intro_video_id: this.item.id
                })
                    .then(() => {
                        this.$set(this.article, 'related_media_intro_video_id', this.item.id)
                    })
            }
        },
        toggleExploreMore(toggle) {
            let publication_id = this.publication.id;
            let article_id = this.article.id;
            let media_id = this.item.id;

            if (!toggle) {//remove as explore more
                this.axios.post('/api/articles/remove_related_media_as_explore_more/' + publication_id + '/' + article_id + '/' + media_id)
                    .then(response => {
                        console.log(response.data);
                    })
                    .catch(error => {
                        if (error) {
                            console.log(error)
                        }
                    })
            } else { //add as explore more
                this.axios.post('/api/articles/add_related_media_as_explore_more/' + publication_id + '/' + article_id + '/' + media_id)
                    .then(response => {
                        console.log(response);
                    })
                    .catch(error => {
                        if (error) {
                            console.log(error)
                        }
                    })
            }
        }
    },
}
</script>
